/* tslint:disable */
/* eslint-disable */
/**
 * EcoCerram API
 * EcoCerram API generated from BE
 *
 * The version of the OpenAPI document: 0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AlternativeSize } from './AlternativeSize';
import {
    AlternativeSizeFromJSON,
    AlternativeSizeFromJSONTyped,
    AlternativeSizeToJSON,
    AlternativeSizeToJSONTyped,
} from './AlternativeSize';
import type { RelatedFile } from './RelatedFile';
import {
    RelatedFileFromJSON,
    RelatedFileFromJSONTyped,
    RelatedFileToJSON,
    RelatedFileToJSONTyped,
} from './RelatedFile';
import type { Certificate } from './Certificate';
import {
    CertificateFromJSON,
    CertificateFromJSONTyped,
    CertificateToJSON,
    CertificateToJSONTyped,
} from './Certificate';
import type { SpecialPallet } from './SpecialPallet';
import {
    SpecialPalletFromJSON,
    SpecialPalletFromJSONTyped,
    SpecialPalletToJSON,
    SpecialPalletToJSONTyped,
} from './SpecialPallet';

/**
 * 
 * @export
 * @interface Stock
 */
export interface Stock {
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    ean?: string;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    size?: StockSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    thickness?: StockThicknessEnum;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    priceForCurrentUser?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    individualPriceForCurrentUser?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    pricePerPackage?: number;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    sellingRateVAT?: number;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    unit?: StockUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    amountPerPackage?: number;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    amountPerPallet?: number;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    packagesOnStock?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    inStock?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    atypicalTile?: boolean;
    /**
     * 
     * @type {SpecialPallet}
     * @memberof Stock
     */
    specialPallet?: SpecialPallet;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    discontinuedDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    discontinuedEanCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    notDiscontinuedEanCode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Stock
     */
    tileFaceImages?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Stock
     */
    showcaseImages?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Stock
     */
    technicalParameters?: Array<StockTechnicalParametersEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Stock
     */
    types?: Array<StockTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Stock
     */
    editions?: Array<StockEditionsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Stock
     */
    surfaces?: Array<StockSurfacesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Stock
     */
    designs?: Array<StockDesignsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Stock
     */
    colors?: Array<StockColorsEnum>;
    /**
     * 
     * @type {Array<AlternativeSize>}
     * @memberof Stock
     */
    alternativeSizes?: Array<AlternativeSize>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Stock
     */
    alternativeStockEanCodes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Stock
     */
    bathroomSeriesStockEanCodes?: Array<string>;
    /**
     * 
     * @type {Array<RelatedFile>}
     * @memberof Stock
     */
    relatedFiles?: Array<RelatedFile>;
    /**
     * 
     * @type {Array<Certificate>}
     * @memberof Stock
     */
    certificates?: Array<Certificate>;
}


/**
 * @export
 */
export const StockSizeEnum = {
    Dimension3060: 'DIMENSION_30_60',
    Dimension6060: 'DIMENSION_60_60',
    Dimension60120: 'DIMENSION_60_120',
    Dimension3030: 'DIMENSION_30_30',
    Dimension120120: 'DIMENSION_120_120',
    Dimension8080: 'DIMENSION_80_80',
    Dimension80160: 'DIMENSION_80_160',
    Dimension100200: 'DIMENSION_100_200',
    Dimension7530: 'DIMENSION_7_5_30',
    Dimension5050: 'DIMENSION_50_50',
    Dimension1590: 'DIMENSION_15_90',
    Dimension4545: 'DIMENSION_45_45',
    Dimension4040: 'DIMENSION_40_40',
    Dimension408283: 'DIMENSION_40_8_28_3',
    Dimension39898: 'DIMENSION_39_8_9_8',
    Dimension2175: 'DIMENSION_21_7_5',
    Dimension25575: 'DIMENSION_25_5_7_5',
    Dimension492145: 'DIMENSION_49_2_14_5',
    Dimension2030: 'DIMENSION_20_30',
    Dimension30120: 'DIMENSION_30_120',
    Dimension20120: 'DIMENSION_20_120'
} as const;
export type StockSizeEnum = typeof StockSizeEnum[keyof typeof StockSizeEnum];

/**
 * @export
 */
export const StockThicknessEnum = {
    Thickness7Mm: 'THICKNESS_7_MM',
    Thickness8Mm: 'THICKNESS_8_MM',
    Thickness2Cm: 'THICKNESS_2_CM',
    Thickness75Mm: 'THICKNESS_7_5_MM',
    Thickness9Mm: 'THICKNESS_9_MM',
    Thickness10Mm: 'THICKNESS_10_MM',
    Thickness5Mm: 'THICKNESS_5_MM',
    Thickness85Mm: 'THICKNESS_8_5_MM',
    Thickness35Mm: 'THICKNESS_35_MM',
    Thickness30Mm: 'THICKNESS_30_MM',
    Thickness55Mm: 'THICKNESS_5_5_MM'
} as const;
export type StockThicknessEnum = typeof StockThicknessEnum[keyof typeof StockThicknessEnum];

/**
 * @export
 */
export const StockUnitEnum = {
    Meter: 'METER',
    Piece: 'PIECE',
    MeterAsPiece: 'METER_AS_PIECE'
} as const;
export type StockUnitEnum = typeof StockUnitEnum[keyof typeof StockUnitEnum];

/**
 * @export
 */
export const StockTechnicalParametersEnum = {
    FrostResistant: 'FROST_RESISTANT',
    NonFrostResistant: 'NON_FROST_RESISTANT',
    AntiSlipR9: 'ANTI_SLIP_R9',
    AntiSlipR10: 'ANTI_SLIP_R10',
    AntiSlipR11: 'ANTI_SLIP_R11',
    ResistanceToSurfaceWearPei1: 'RESISTANCE_TO_SURFACE_WEAR_PEI_1',
    ResistanceToSurfaceWearPei2: 'RESISTANCE_TO_SURFACE_WEAR_PEI_2',
    ResistanceToSurfaceWearPei3: 'RESISTANCE_TO_SURFACE_WEAR_PEI_3',
    ResistanceToSurfaceWearPei4: 'RESISTANCE_TO_SURFACE_WEAR_PEI_4',
    Rectified: 'RECTIFIED'
} as const;
export type StockTechnicalParametersEnum = typeof StockTechnicalParametersEnum[keyof typeof StockTechnicalParametersEnum];

/**
 * @export
 */
export const StockTypesEnum = {
    BathroomSeries: 'BATHROOM_SERIES',
    FacadeCladding: 'FACADE_CLADDING',
    Tiling: 'TILING',
    Flooring: 'FLOORING',
    Decoration: 'DECORATION',
    MosaicHexagon: 'MOSAIC_HEXAGON'
} as const;
export type StockTypesEnum = typeof StockTypesEnum[keyof typeof StockTypesEnum];

/**
 * @export
 */
export const StockEditionsEnum = {
    New: 'NEW',
    Preparing: 'PREPARING',
    Discount: 'DISCOUNT',
    Discontinued: 'DISCONTINUED',
    ClearanceSale: 'CLEARANCE_SALE'
} as const;
export type StockEditionsEnum = typeof StockEditionsEnum[keyof typeof StockEditionsEnum];

/**
 * @export
 */
export const StockSurfacesEnum = {
    Matte: 'MATTE',
    Gloss: 'GLOSS',
    HighGloss: 'HIGH_GLOSS',
    Carving: 'CARVING',
    Texture: 'TEXTURE'
} as const;
export type StockSurfacesEnum = typeof StockSurfacesEnum[keyof typeof StockSurfacesEnum];

/**
 * @export
 */
export const StockDesignsEnum = {
    Wood: 'WOOD',
    Stone: 'STONE',
    Concrete: 'CONCRETE',
    Abstract: 'ABSTRACT',
    Universal: 'UNIVERSAL',
    Marble: 'MARBLE',
    Metallic: 'METALLIC'
} as const;
export type StockDesignsEnum = typeof StockDesignsEnum[keyof typeof StockDesignsEnum];

/**
 * @export
 */
export const StockColorsEnum = {
    Beige: 'BEIGE',
    Red: 'RED',
    Brown: 'BROWN',
    Green: 'GREEN',
    Yellow: 'YELLOW',
    Blue: 'BLUE',
    White: 'WHITE',
    Black: 'BLACK',
    Gray: 'GRAY',
    Other: 'OTHER'
} as const;
export type StockColorsEnum = typeof StockColorsEnum[keyof typeof StockColorsEnum];


/**
 * Check if a given object implements the Stock interface.
 */
export function instanceOfStock(value: object): value is Stock {
    return true;
}

export function StockFromJSON(json: any): Stock {
    return StockFromJSONTyped(json, false);
}

export function StockFromJSONTyped(json: any, ignoreDiscriminator: boolean): Stock {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'ean': json['ean'] == null ? undefined : json['ean'],
        'name': json['name'] == null ? undefined : json['name'],
        'size': json['size'] == null ? undefined : json['size'],
        'thickness': json['thickness'] == null ? undefined : json['thickness'],
        'price': json['price'] == null ? undefined : json['price'],
        'priceForCurrentUser': json['priceForCurrentUser'] == null ? undefined : json['priceForCurrentUser'],
        'individualPriceForCurrentUser': json['individualPriceForCurrentUser'] == null ? undefined : json['individualPriceForCurrentUser'],
        'pricePerPackage': json['pricePerPackage'] == null ? undefined : json['pricePerPackage'],
        'sellingRateVAT': json['sellingRateVAT'] == null ? undefined : json['sellingRateVAT'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'amountPerPackage': json['amountPerPackage'] == null ? undefined : json['amountPerPackage'],
        'amountPerPallet': json['amountPerPallet'] == null ? undefined : json['amountPerPallet'],
        'packagesOnStock': json['packagesOnStock'] == null ? undefined : json['packagesOnStock'],
        'inStock': json['inStock'] == null ? undefined : json['inStock'],
        'atypicalTile': json['atypicalTile'] == null ? undefined : json['atypicalTile'],
        'specialPallet': json['specialPallet'] == null ? undefined : SpecialPalletFromJSON(json['specialPallet']),
        'discontinuedDescription': json['discontinuedDescription'] == null ? undefined : json['discontinuedDescription'],
        'discontinuedEanCode': json['discontinuedEanCode'] == null ? undefined : json['discontinuedEanCode'],
        'notDiscontinuedEanCode': json['notDiscontinuedEanCode'] == null ? undefined : json['notDiscontinuedEanCode'],
        'tileFaceImages': json['tileFaceImages'] == null ? undefined : json['tileFaceImages'],
        'showcaseImages': json['showcaseImages'] == null ? undefined : json['showcaseImages'],
        'technicalParameters': json['technicalParameters'] == null ? undefined : json['technicalParameters'],
        'types': json['types'] == null ? undefined : json['types'],
        'editions': json['editions'] == null ? undefined : json['editions'],
        'surfaces': json['surfaces'] == null ? undefined : json['surfaces'],
        'designs': json['designs'] == null ? undefined : json['designs'],
        'colors': json['colors'] == null ? undefined : json['colors'],
        'alternativeSizes': json['alternativeSizes'] == null ? undefined : ((json['alternativeSizes'] as Array<any>).map(AlternativeSizeFromJSON)),
        'alternativeStockEanCodes': json['alternativeStockEanCodes'] == null ? undefined : json['alternativeStockEanCodes'],
        'bathroomSeriesStockEanCodes': json['bathroomSeriesStockEanCodes'] == null ? undefined : json['bathroomSeriesStockEanCodes'],
        'relatedFiles': json['relatedFiles'] == null ? undefined : ((json['relatedFiles'] as Array<any>).map(RelatedFileFromJSON)),
        'certificates': json['certificates'] == null ? undefined : ((json['certificates'] as Array<any>).map(CertificateFromJSON)),
    };
}

export function StockToJSON(json: any): Stock {
    return StockToJSONTyped(json, false);
}

export function StockToJSONTyped(value?: Stock | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'ean': value['ean'],
        'name': value['name'],
        'size': value['size'],
        'thickness': value['thickness'],
        'price': value['price'],
        'priceForCurrentUser': value['priceForCurrentUser'],
        'individualPriceForCurrentUser': value['individualPriceForCurrentUser'],
        'pricePerPackage': value['pricePerPackage'],
        'sellingRateVAT': value['sellingRateVAT'],
        'unit': value['unit'],
        'amountPerPackage': value['amountPerPackage'],
        'amountPerPallet': value['amountPerPallet'],
        'packagesOnStock': value['packagesOnStock'],
        'inStock': value['inStock'],
        'atypicalTile': value['atypicalTile'],
        'specialPallet': SpecialPalletToJSON(value['specialPallet']),
        'discontinuedDescription': value['discontinuedDescription'],
        'discontinuedEanCode': value['discontinuedEanCode'],
        'notDiscontinuedEanCode': value['notDiscontinuedEanCode'],
        'tileFaceImages': value['tileFaceImages'],
        'showcaseImages': value['showcaseImages'],
        'technicalParameters': value['technicalParameters'],
        'types': value['types'],
        'editions': value['editions'],
        'surfaces': value['surfaces'],
        'designs': value['designs'],
        'colors': value['colors'],
        'alternativeSizes': value['alternativeSizes'] == null ? undefined : ((value['alternativeSizes'] as Array<any>).map(AlternativeSizeToJSON)),
        'alternativeStockEanCodes': value['alternativeStockEanCodes'],
        'bathroomSeriesStockEanCodes': value['bathroomSeriesStockEanCodes'],
        'relatedFiles': value['relatedFiles'] == null ? undefined : ((value['relatedFiles'] as Array<any>).map(RelatedFileToJSON)),
        'certificates': value['certificates'] == null ? undefined : ((value['certificates'] as Array<any>).map(CertificateToJSON)),
    };
}

